import { Lockup } from './Lockup'

export function RouteFallback() {
  return (
    <div className="min-h-screen bg-ink flex flex-col items-center justify-center gap-6">
      <Lockup size="md" kineticSettle />
      <div className="w-8 h-8 rounded-full border-2 border-line border-t-aurora-cyan animate-spin" />
    </div>
  )
}
